import { PaymentProduct, Session } from "onlinepayments-sdk-client-js";
import { useCallback, useEffect, useState } from "react";

export const usePaymentSession = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [paymentProduct, setPaymentProduct] = useState<PaymentProduct | null>(
    null
  );

  const getSession = useCallback(async () => {
    const sessionRequest = await fetch(
      (process.env.REACT_APP_API_URL || "") + "/google-pay/session",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(process.env.REACT_APP_PUBLIC_URL?.includes("ngrok")
            ? { "ngrok-skip-browser-warning": "1" }
            : {}),
        },
      }
    );
    const sessionInformation = await sessionRequest.json();
    const session = new Session({
      clientSessionId: sessionInformation.body.clientSessionId,
      customerId: sessionInformation.body.customerId,
      clientApiUrl: sessionInformation.body.clientApiUrl,
      assetUrl: sessionInformation.body.assetUrl,
    });
    return session;
  }, []);

  const getPaymentProduct = useCallback(async () => {
    if (session) {
      const productId = parseInt(
        process.env.REACT_APP_GOOGLE_PAY_PRODUCT_ID || ""
      );
      const paymentProduct = await session.getPaymentProduct(productId, {
        amountOfMoney: {
          amount: 100,
          currencyCode: process.env.REACT_APP_GOOGLE_PAY_CURRENCY_CODE || "",
        },
        countryCode: process.env.REACT_APP_GOOGLE_PAY_COUNTRY_CODE || "",
      });
      return paymentProduct;
    }
    return null;
  }, [session]);

  useEffect(() => {
    getSession().then((session) => {
      setSession(session);
    });
  }, [getSession]);

  useEffect(() => {
    if (session) {
      getPaymentProduct().then((paymentProduct) => {
        setPaymentProduct(paymentProduct);
      });
    }
  }, [session]);

  return { paymentProduct, session };
};
